import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useLanguage } from "../lib/LanguageContext";
import { modeLabel } from "../lib/translations";
import { cn } from "../lib/cn";
export const ModeBadge = ({ mode, className = "", size = "sm" }) => {
    const { lang } = useLanguage();
    const label = modeLabel(lang, mode);
    const isLive = mode === "live";
    return (_jsx("span", { className: cn("inline-flex items-center rounded-full font-semibold uppercase tracking-wide", size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs", isLive
            ? "bg-rose-100 text-rose-800 ring-1 ring-rose-200 dark:bg-rose-950/50 dark:text-rose-200 dark:ring-rose-800/60"
            : "bg-sky-100 text-sky-800 ring-1 ring-sky-200 dark:bg-sky-950/50 dark:text-sky-200 dark:ring-sky-800/60", className), children: label }));
};
